<template>
  <div class="subscribe-box">
    <div class="form-item">
      <div class="tip gray">
        <span class="need">*</span>
        <span>基本信息(必须与简历上保持一致)</span>
      </div>
      <div class="input-list">
        <div class="input-item">
          <div class="title">姓名</div>
          <div class="detail">
            <input type="text" v-model="subscribeObj.name" placeholder="请输入姓名">
          </div>
        </div>
        <div class="input-item">
          <div class="title">手机号</div>
          <div class="detail">
            <input type="text" maxlength="11" v-model="subscribeObj.phone" placeholder="请输入手机号, 必须与简历相符">
          </div>
        </div>
         <div class="input-item">
          <div class="title">性别</div>
          <div class="detail">
            <div class="my-radio" 
              :class="{active: subscribeObj.gender == 0}" 
              @click="subscribeObj.gender = 0"
              style="display: inline-block">
              <span class="circle"></span>
              <span>女</span>
            </div>
            <div class="my-radio" 
              :class="{active: subscribeObj.gender == 1}" 
              @click="subscribeObj.gender = 1"
              style="display: inline-block">
              <span class="circle"></span>
              <span>男</span>
            </div>
          </div>
        </div>
        <div class="input-item">
          <div class="title">邮箱</div>
          <div class="detail">
            <input type="text" v-model="subscribeObj.email" placeholder="请输入邮箱">
          </div>
        </div>
        <div class="input-item">
          <div class="title">出生年份</div>
          <div class="detail" @click="showYearPick = true">
            <span class="gray" v-show="!selectedYear">未选择，请选择</span>
            <span v-show="selectedYear">{{selectedYear}}</span>
          </div>
        </div>
        <div class="input-item">
          <div class="title">当前状态</div>
          <div class="detail">
            <div class="my-radio"
              :class="{active: selectedWorkStatus == 1}" 
              @click="selectedWorkStatus = 1"
              style="display: inline-block">
              <span class="circle"></span>
              <span>应届生</span>
            </div>
            <div class="my-radio"
              :class="{active: selectedWorkStatus == 2}" 
              @click="selectedWorkStatus = 2"
              style="display: inline-block">
              <span class="circle"></span>
              <span>已离职</span>
            </div>
            <div class="my-radio"
              :class="{active: selectedWorkStatus == 3}" 
              @click="selectedWorkStatus = 3"
              style="display: inline-block">
              <span class="circle"></span>
              <span>在职</span>
            </div>
          </div>
        </div>
        <div class="input-item" style="align-items: baseline">
          <div class="title">到岗时间</div>
          <div class="detail">
            <div class="my-radio"
              :class="{active: selectedShowTime == 0}" 
              @click="selectedShowTime = 0"
              style="display: inline-block">
              <span class="circle"></span>
              <span>随时入职</span>
            </div>
            <div class="my-radio"
            :class="{active: selectedShowTime == 1}" 
              @click="selectedShowTime = 1"
              style="display: inline-block">
              <span class="circle"></span>
              <span>一周内</span>
            </div>
            <div class="my-radio"
              :class="{active: selectedShowTime == 2}" 
              @click="selectedShowTime = 2"
              style="display: inline-block">
              <span class="circle"></span>
              <span>两周内</span>
            </div>
             <div class="my-radio"
              :class="{active: selectedShowTime == 3}" 
              @click="selectedShowTime = 3"
              style="display: inline-block">
              <span class="circle"></span>
              <span>一个月内</span>
            </div>
             <div class="my-radio"
              :class="{active: selectedShowTime == 4}" 
              @click="selectedShowTime = 4"
              style="display: inline-block">
              <span class="circle"></span>
              <span>一个月以后</span>
            </div>
          </div>
        </div>
        <div class="input-item">
          <div class="title">常住地</div>
          <div class="detail">
            <div class="my-radio"
             :class="{active: workCity == '上海'}" 
              @click="workCity = '上海'"
              style="display: inline-block">
              <span class="circle"></span>
              <span>上海</span>
            </div>
            <div class="my-radio"
              :class="{active: workCity == '其它'}" 
              @click="workCity = '其它'"
              style="display: inline-block">
              <span class="circle"></span>
              <span>其它</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-item">
      <div class="tip gray">
        <span class="need">*</span>
        <span>最高学历</span>
      </div>
      <div class="input-list">
        <div class="form-radio-inner">
          <div class="my-radio" 
            :class="{active: subscribeObj.activeEducation == 4}" 
            @click="subscribeObj.activeEducation = 4"
            style="display: inline-block">
            <span class="circle"></span>
            <span>大专</span>
          </div>
          <div class="my-radio" 
            :class="{active: subscribeObj.activeEducation == 1}" 
            @click="subscribeObj.activeEducation = 1"
            style="display: inline-block">
            <span class="circle"></span>
            <span>本科</span>
          </div>
          <div class="my-radio" 
            :class="{active: subscribeObj.activeEducation == 2}" 
            @click="subscribeObj.activeEducation = 2"
            style="display: inline-block">
            <span class="circle"></span>
            <span>硕士</span>
          </div>
          <div class="my-radio" 
            :class="{active: subscribeObj.activeEducation == 3}" 
            @click="subscribeObj.activeEducation = 3"
            style="display: inline-block">
            <span class="circle"></span>
            <span>博士</span>
          </div>
        </div>
      </div>
    </div>
    <div class="form-item" v-show="subscribeObj.activeEducation == 4">
      <div class="tip gray">
        <span class="need">*</span>
        <span>大专院校</span>
      </div>
      <div class="input-list">
        <textarea cols="30" rows="3" v-model="subscribeObj.juniorCollege" placeholder="请输入大专院校"></textarea>
      </div>
    </div>
    <div class="form-item" v-show="subscribeObj.activeEducation == 1 || subscribeObj.activeEducation == 2 ">
      <div class="tip gray">
        <span class="need">*</span>
        <span>本科院校</span>
      </div>
      <div class="input-list">
        <textarea cols="30" rows="3" v-model="subscribeObj.undergraduate" placeholder="请输入本科院校"></textarea>
      </div>
    </div>
    <div class="form-item" v-show="subscribeObj.activeEducation == 2 || subscribeObj.activeEducation == 3">
      <div class="tip gray">
        <span class="need">*</span>
        <span>硕士院校</span>
      </div>
      <div class="input-list">
        <textarea cols="30" rows="3" v-model="subscribeObj.master" placeholder="请输入硕士院校"></textarea>
      </div>
    </div>
    <div class="form-item" v-show="subscribeObj.activeEducation == 3">
      <div class="tip gray">
        <span class="need">*</span>
        <span>博士院校</span>
      </div>
      <div class="input-list">
        <textarea cols="30" rows="3" v-model="subscribeObj.doctor" placeholder="请输入博士院校"></textarea>
      </div>
    </div>
    <div class="form-item">
      <div class="tip gray">
        <span class="need">*</span>
        <span>场次选择</span>
      </div>
      <div class="input-list">
        <div class="form-radio-inner">
          <div class="my-radio gray" v-if="subscribeData.length == 0">抱歉，目前没有可预约场次</div>
          <div class="my-radio" 
            :class="{
              active: subscribeObj.subscribeId == item.id,
              disabled: item.peopleCount >= item.peopleNumberLimit
            }"
            @click="chooseSubscribe(item)"
            v-for="item in subscribeData" :key="item.id">
            <span class="circle"></span>
            <span>{{item.scheduleDate + ' ' + item.startTime + ' [' + getTableJobs(item.posts) + '] ' + item.remark}}</span>
            <span v-show="item.peopleCount >= item.peopleNumberLimit">(已约满)</span>
          </div>
        </div>
      </div>
    </div>
    <div class="form-item">
      <div class="my-button" @click="openModal">确认预约</div>
    </div>
    <div class="tip gray">提示：预约成功后将无法取消，请慎重选择笔试时间</div>
    <!-- 信息确认弹窗 -->
    <div class="modal" v-show="showModal">
      <div class="modal-inner">
       <div class="title">预约信息确认</div>
        <div class="body">
          <div style="margin-bottom: 12px">您的本次预约信息为</div>
          <div class="body-inner">
            <div>
              <div class="body-item">
                <span class="gray">姓名</span>
                <span>{{subscribeObj.name}}</span>
              </div>
              <div class="body-item">
                <span class="gray">电话</span>
                <span>{{subscribeObj.phone}}</span>
              </div>
              <div class="body-item">
                <span class="gray">邮箱</span>
                <span>{{subscribeObj.email}}</span>
              </div>
              <div class="body-item">
                <span class="gray">场次</span>
                <span>{{subscribeObj.subscribeValue}}</span>
              </div>
              <div class="body-item">
                <span class="gray">岗位</span>
                <span>{{subscribeObj.jobs}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="small-button plain border" @click="showModal = false">取消</div>
          <div class="small-button primary" @click="confirmSubscribe">
            <img v-show="actionLoading" src="@/assets/loading.png">
            <span>确认</span>
          </div>
        </div>
      </div>
    </div>
    <div class="year-picker" v-show="showYearPick" @click="showYearPick = false">
      <div class="year-picker-inner" @click.stop="">
        <div class="header">
          <span class="before" @click.stop="currentYear-=10">
            <img src="@/assets/next-btn.png">
          </span>
          <span style="margin: 0 20px">{{currentYear}}</span>
          <span class="next" @click.stop="currentYear+=10">
            <img src="@/assets/next-btn.png">
          </span>
        </div>
        <div class="body">
          <span 
            @click.stop="selectedYear = item; showYearPick = false"
            :class="{active: selectedYear == item}"
            v-for="item in yearArr">{{item}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import Message from '@/components/Message.vue'
import {calendar,inlineCalendar} from 'vue-mobile-calendar';

export default {
  name: 'Subscribe',
  components: {},
  data() {
    return {
      showModal: false,
      calendarShow: false,
      selectedDate: '',
      //录入的信息
      subscribeObj: {
        name: '',
        phone: '',
        email: '',
        activeEducation: 1,
        undergraduate: '',
        juniorCollege: '',
        master: '',
        doctor: '',
        subscribeId: 0,
        subscribeValue: '',
        fastTime: '',
        gender: 0
      },
      subscribeData: [],
      actionLoading: false,
      currentYear: 1990,
      selectedYear: null,
      selectedWorkStatus: 2,
      selectedShowTime: 0,
      workCity: '上海',
      yearArr: [],
      showYearPick: false
    };
  },
  watch: {
    currentYear(){
      this.yearArr = []
      for(var i = 0; i < 10; i++){
        this.yearArr.push(this.currentYear + i)
      }
    }
  },
  mounted () {
    this.forbidScroll()
    this.getsubscribeObj()
    for(var i = 0; i < 10; i++){
      this.yearArr.push(this.currentYear + i)
    }
  },
  methods: {
    getTableJobs(arr) {
      var text = ''
      arr.forEach((item, index) => {
        var symbol = index == 0?'':'、'
        text+=symbol + item.postName
      })
      return text || '-'
    },
    changeDate (d) {
      this.selectedDate = d.format('YYYY-MM-DD')
      this.calendarShow = false
    },
    confirmSubscribe () {
      //保存预约
      var that = this
      that.actionLoading = true
      
      this.$http(
        '/user/Booking/AddBooking', 
        {
          "scheduleId": this.subscribeObj.subscribeId,
          "name": this.subscribeObj.name,
          "highestDegree": this.subscribeObj.activeEducation,
          "phoneNumber": this.subscribeObj.phone,
          "email": this.subscribeObj.email,
          "birthday": this.selectedYear + '-01-01',
          "juniorCollege": this.subscribeObj.juniorCollege,
          "undergraduateCollege": this.subscribeObj.undergraduate,
          "masterCollege": this.subscribeObj.master,
          "doctoralCollege": this.subscribeObj.doctor,
          "workingStatus": this.selectedWorkStatus?this.selectedWorkStatus:'',
          "currentCity": this.workCity,
          "showUpDate": this.selectedShowTime,
          'gender': this.subscribeObj.gender
        }
      )
      .then(function (res) {
        if(res.messageLevel == 1){
          that.actionLoading = false
          that.$router.push({ name: 'Result', params: { 
            type: 'success',
            name: that.subscribeObj.name,
            phone: that.subscribeObj.phone,
            email: that.subscribeObj.email,
            subscribeValue: that.subscribeObj.subscribeValue,
          }})
        }else{
          that.$message({
            type: 'success',
            text: res.message
          });
          that.getsubscribeObj()
          that.actionLoading = false
        }
      })
      .catch(function (error) {
        that.actionLoading = false
        that.$router.push({ name: 'Result', params: {
          type: 'fail',
          status: error.messageLevel,
          message: error.message
        }})
        that.getsubscribeObj()
      })
    },
    getsubscribeObj () {
      var that = this
      this.$http(
        '/user/Schedule/GetSchedules', 
        {}
      )
      .then(function (res) {
        that.subscribeData = res.data
      })
      .catch(function (error) {
        that.$message({
          type: 'success',
          text: '访问出错了,请稍后重试',
        });
      })
    },
    //禁止滚动穿透
    forbidScroll () {
      var modal = document.getElementsByClassName('modal')[0]
      modal.addEventListener('touchmove', function(e) {
        e.preventDefault();
      }, false);
    },
    openModal () {
      if(!this.subscribeObj.name){
        this.$message({
          type: 'success',
          text: '姓名不能为空',
        });
        return false; 
      }
      if(!(/^1[3456789]\d{9}$/.test(this.subscribeObj.phone))){ 
        this.$message({
          type: 'success',
          text: '手机号格式不正确',
        });
        return false; 
      }
      if(!this.subscribeObj.email){
        this.$message({
          type: 'success',
          text: '邮箱不能为空',
        });
        return false; 
      }
      if(!this.selectedYear){
        this.$message({
          type: 'success',
          text: '出生年份不能为空',
        });
        return false; 
      }
      if(!this.subscribeObj.undergraduate && !this.subscribeObj.juniorCollege){
        this.$message({
          type: 'success',
          text: '本科或专科院校不能为空',
        });
        return false; 
      }
      if((this.subscribeObj.activeEducation == 2 || this.activeEducation == 3) && !this.subscribeObj.master){
        this.$message({
          type: 'success',
          text: '硕士院校不能为空',
        });
        return false; 
      }
      if(this.subscribeObj.activeEducation == 3 && !this.subscribeObj.doctor){
        this.$message({
          type: 'success',
          text: '博士院校不能为空',
        });
        return false; 
      }
      if(!this.subscribeObj.subscribeId){
        this.$message({
          type: 'success',
          text: '请选择场次',
        });
        return false; 
      }
      this.showModal = true
    },
    chooseSubscribe (item) {
      if(item.peopleCount >= item.peopleNumberLimit){
        this.$message({
          type: 'success',
          text: '当前场次不可预约',
        });
        return false
      }else{
        this.$set(this.subscribeObj, 'subscribeId', item.id)
        this.$set(this.subscribeObj, 'subscribeValue', item.scheduleDate + ' ' + item.startTime + ' ' + item.remark )
        this.$set(this.subscribeObj, 'jobs', this.getTableJobs(item.posts))
      }
    }
  }
}
</script>
<style scoped>
  input{
    border: 0;
    outline: 0;
    padding: 0;
  }
  .subscribe-box{
    padding: 0 10px;
    background: #F5F5F5;
    padding-bottom: 96px;
    min-height: 100vh;
  }
  .input-item{
    display: flex;
    align-items: center;
    background: #fff;
    padding: 16px 12px;
  }
  .form-item .tip{
    text-align: left;
    font-size: 13px;
    padding: 16px 0;
  }
  .tip .need{
    color: #ff0000;
  }
  .input-list{
    border-radius: 4px;
    overflow: hidden;
  }
  .input-item .title{
    width: 80px;
    min-width: 80px;
    text-align: left;
  }
  .input-item input{
    font-size: 15px;
    width: 100%;
  }
  .input-item .detail{
    flex: auto;
    text-align: left;
    font-size: 15px;
  }
  .input-item+.input-item{
    border-top: 1px solid #F2F6FC;
  }
  .input-list textarea{
    width: 100%;
    border: 0;
    outline: 0;
    padding: 0;
    box-sizing: border-box;
    padding: 12px;
    display: block;
    font-size: 15px;
  }
  .selected-date-box{
    font-size: 15px;
    background: #fff;
    line-height: 40px;
    padding: 0 12px;
    text-align: left;
  }
  .selected-date-box .title{
    margin-right: 12px;
  }
  .selected-date-box .date{
    font-weight: bold;
  }
  .my-radio{
    display: block;
  }
  .my-radio span{
    display: inline-block;
    vertical-align: middle;
  }
  .my-radio .circle{
    width: 16px;
    height: 16px;
    background: #f1f1f1;
    display: inline-block;
    border-radius: 16px;
    position: relative;
    margin-right: 4px;
    min-width: 16px;
  }
  .my-radio .circle::before{
    content: '';
    width: 8px;
    height: 8px;
    background: #fff;
    border-radius: 8px;
    position: absolute;
    left: 4px;
    top: 4px;
  }
  .form-radio-inner{
    background: #fff;
    text-align: left;
    padding: 12px;
  }
  .my-radio{
    margin-right: 20px;
    margin-top: 5px;
    margin-bottom: 5px;
    font-size: 15px;
    display: flex;
    align-items: center;
  }
  .my-radio span:last-child{
    flex: auto;
  }
  .my-button{
    background: #3296FF;
    color: #fff;
    line-height: 48px;
    border-radius: 4px;
    margin-top: 20px;
  }
  .my-button:active{
    background: #0075F0;
  }
  .tip{
    font-size: 13px;
    padding-top: 12px;
  }
  .my-radio.active .circle{
    background: #3296FF;
  }
  .my-radio.active span{
    color: #3296FF;
  }
  .my-radio.disabled{
    color: #999;
    cursor: not-allowed;
  }
  .modal{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
  .modal-inner{
    background: #fff;
    position: absolute;
    z-index: 100;
    left: 10px;
    top: calc(50% - 148px);
    width: calc(100% - 20px);
    text-align: left;
    border-radius: 4px;
  }
  .modal .title{
    border-bottom: 1px solid #F2F6FC;
    padding: 10px 0;
    text-align: center;
  }
  .modal .body{
    padding: 12px;
  }
  .modal .footer{
    padding: 12px;
    text-align: right;
    border-top: 1px solid #F2F6FC;
  }
  .modal .body{
    padding: 12px;
    font-size: 14px;
  }
  .modal .body-inner{
    background: #f5f5f5;
    padding: 12px;
    border-radius: 4px;
  }
  .modal .footer .small-button{
    display: inline-block;
    box-sizing: border-box;
    font-size: 13px;
  }
  .small-button+.small-button{
    margin-left: 20px;
  }
  .modal .footer .small-button.plain{
    color: #333;
    padding: 8px 20px;
    border-radius: 4px;
  }
  .modal .footer .small-button.plain:active{
    background: #f1f1f1;
  }
  .modal .footer .small-button.primary{
    background: #3296FF;
    color: #fff;
    padding: 8px 20px;
    border-radius: 4px;
    border: 1px solid #3296FF;
  }
  .modal .footer .small-button.primary:active{
    background: #0075F0;
  }
  .body-item+.body-item{
    margin-top: 10px;
  }
  .body-item .gray{
    margin-right: 10px;
  }
  .small-button img{
    width: 14px;
    height: 14px;
    margin-right: 8px;
    animation: rotate 2s linear infinite;
    display: inline-block;
    vertical-align: middle;
  }
  .small-button span{
    display: inline-block;
    vertical-align: middle;
  }
  .year-picker{
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    left: 0;
    top: 0;
  }
  .year-picker-inner{
    position: absolute;
    top: calc(50% - 80px);
    width: 90%;
    left: 5%;
    background: #fff;
  }
  .year-picker-inner img{
    width: 20px;
    height: 20px;
    display: block;
  }
  .year-picker-inner .header{
    display: flex;
    text-align: center;
    justify-content: center;
    padding: 8px 0;
    border-bottom: 1px solid #F2F6FC;
  } 
  .header .before img{
    transform: rotate(180deg);
  }
  .header span{
    display: inline-block;
    line-height: 20px;
  }
  .year-picker-inner .body{
    display: flex;
    flex-wrap: wrap;
    padding: 20px 0;
  }
  .year-picker-inner .body span{
    min-width: 20%;
    margin: 10px 0;
  }
  .year-picker-inner .body span.active{
    color: #3296FF;
  }
  @keyframes rotate{from{transform: rotate(0deg)}
    to{transform: rotate(359deg)}
  }
</style>

